import { all, fork } from "redux-saga/effects";

import LayoutSaga from "store/layout/saga";
import authSaga from "store/auth/saga";
import userSaga from "store/users/saga";
import clientSaga from "store/clients/saga";
import vehicleSaga from "store/vehicles/saga";
import rateSaga from "store/rates/saga";
import billingSaga from "store/billing/saga";
import paymentSaga from "store/payments/saga";

export default function* rootSaga() {
  yield all([
    LayoutSaga(),
    fork(authSaga),
    fork(userSaga),
    fork(clientSaga),
    fork(vehicleSaga),
    fork(rateSaga),
    fork(billingSaga),
    fork(paymentSaga),
  ]);
}
